import React from 'react';
import { Sunrise, Coffee, Moon } from 'lucide-react';
export function FuturePacing() {
  return <section className="py-10 bg-white" data-id="element-288">
      <div className="container mx-auto px-4" data-id="element-289">
        <div className="max-w-4xl mx-auto" data-id="element-290">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-gray-800" data-id="element-291">
            Vida Natural y Funcional
          </h2>
          <p className="text-xl text-center mb-12" data-id="element-292">
            Visualiza una semana completa sin medicamentos, sin efectos
            colaterales, sin dolor crónico acechando tu día.
          </p>
          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-293">
            <div className="bg-blue-50 p-6 rounded-xl text-center" data-id="element-294">
              <div className="flex justify-center mb-4" data-id="element-295">
                <Sunrise size={40} className="text-blue-600" data-id="element-296" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-297">
                Despiertas con claridad
              </h3>
              <p data-id="element-298">
                Sin la neblina mental de los medicamentos. Solo tú, descansado y
                alerta.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl text-center" data-id="element-299">
              <div className="flex justify-center mb-4" data-id="element-300">
                <Coffee size={40} className="text-blue-600" data-id="element-301" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-302">Trabajas con energía</h3>
              <p data-id="element-303">
                Mantén tu rendimiento sin interrupciones por dolor o efectos
                secundarios.
              </p>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl text-center" data-id="element-304">
              <div className="flex justify-center mb-4" data-id="element-305">
                <Moon size={40} className="text-blue-600" data-id="element-306" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-307">
                Descansas profundamente
              </h3>
              <p data-id="element-308">
                Un sueño reparador natural, sin la interferencia de químicos.
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-309">
            <p className="text-xl mb-6" data-id="element-310">
              Y lo lograste por ti. Sin fármacos. Sin riesgos.
            </p>
            <p className="text-xl font-semibold text-green-600" data-id="element-311">
              🌱 Tu cuerpo ya sabe qué hacer. Dale la oportunidad.
            </p>
          </div>
        </div>
      </div>
    </section>;
}